import usFlag from "../assets/images/flags/us.jpg"
import spain from "../assets/images/flags/spain.jpg"
import germany from "../assets/images/flags/germany.jpg"
import italy from "../assets/images/flags/italy.jpg"
import russia from "../assets/images/flags/russia.jpg"
import greece from "../assets/images/flags/greece.jpg"

const languages : Object = {
  en: {
    label: "English",
    flag: usFlag,
  },
  el: {
    label: "Greek",
    flag: greece,
  },
 
}

export default languages
